import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { UserService } from 'app/Shared/Services/user.service';
import { default as DefaultFilterJSON } from 'app/Shared/Constant/Default Filter JSON/Details-Order-Viewer.json';
import { default as ODRGridColumnsJSON } from 'app/Pages/odr/processed-transactions/processed-transactions-columns.json';
import { DataService } from 'app/Shared/Services/data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormsModule, NgModel } from '@angular/forms';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { forkJoin, map } from 'rxjs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { DialogModule } from 'primeng/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TurboTableComponent } from 'app/Shared/Component/turbo-table/turbo-table.component';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { asBlob, generateCsv } from 'export-to-csv';
import saveAs from 'file-saver';

@Component({
  selector: 'app-odr-order-viewer',
  templateUrl: './odr-order-viewer.component.html',
  imports: [TurboTableComponent, MatCheckboxModule, MatAccordion, MatExpansionModule, MatChipsModule, MatProgressSpinner, MatTabsModule, DialogModule, MatTooltipModule, FormsModule, ButtonModule, CommonModule, ToastModule],
  providers: [],
  styleUrls: ['./odr-order-viewer.component.scss']
})
export class ODROrderViewerComponent implements OnInit, OnDestroy {
  @Input('DefaultFilterArray') DefaultFilterArray: any = [];
  @Input('isOpenClose') isOpenClose!: boolean;
  @Input('SelectedRow') SelectedRow: any = [];
  @Input('PageName') PageName: any;
  @Output() CloseEvent: EventEmitter<any> = new EventEmitter();
  DefaultFilterColumns;
  public FilterData: any = [];
  fromdate: any;
  todate: any;
  OrderGridCols: any = [];
  TradeGridCols: any = [];
  RouteGridCols: any = [];
  OrderGridColumns: any = [];
  TradeGridColumns: any = [];
  RouteGridColumns: any = [];
  OrderCSVGridHeaders: any = [];
  TradeCSVGridHeaders: any = [];
  RouteCSVGridHeaders: any = [];

  Dataset: any = [];
  panelOpenState: boolean = true;
  FilterpanelOpenState: boolean = true;
  checkedAccordationView: boolean = true;
  selectedTab = new FormControl(0);
  labelPosition = 'after';
  Limit: any = { 'Start': '0', 'End': '20' };
  CSVLimit: any = { 'Start': '0', 'End': '20' };
  Tradedataset: any = [];
  Orderdataset: any = [];
  Routedataset: any = [];
  isOrderdatasetLoading!: boolean;
  isTradedatasetLoading!: boolean;
  isRoutedatasetLoading!: boolean;
  booleanFieldList:any =[];

  subscription: any;
  OrderId: any;
  OSMId!: string;
  ComplianceOrderId: any;
  Symbol: any;
  CancelOrderID: any;
  expandedPanel: boolean[] = [true];

  constructor(
    private datePipe: DatePipe,
    private gridService: GridService,
    private emitterService: EmitterService,
    private dataService: DataService,
    public constantService: ConstantService,
    private route: ActivatedRoute,
    public UserService: UserService,
    private messageService: MessageService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService) {
    window.scrollTo(0, 0);
    let GridColumns: any = ODRGridColumnsJSON["Grid-Columns"];
    // GridColumns.splice(0, 1);
    this.OrderGridCols = [];
    this.TradeGridCols = [];
    this.RouteGridCols = [];
    this.OrderGridColumns = GridColumns;
    this.TradeGridColumns = GridColumns;
    this.RouteGridColumns = GridColumns;
    this.OrderGridCols = this.gridService.getGridColumns(this.OrderGridColumns);
    this.OrderGridCols.splice(0, 1);
    this.TradeGridCols = this.gridService.getGridColumns(this.TradeGridColumns);
    this.TradeGridCols.splice(0, 1);
    this.RouteGridCols = this.gridService.getGridColumns(this.RouteGridColumns);
    this.RouteGridCols.splice(0, 1);
    this.DefaultFilterColumns = DefaultFilterJSON;
    let booleanFieldList = GridColumns.filter((field: any) => field.datatype.toLowerCase() === 'boolean');
    this.booleanFieldList[0] = booleanFieldList.map(function(gridItem: { [x: string]: any; }) {return gridItem["mappingkey"]})
    // Order Viewer CSV Header & Fields

    this.OrderCSVGridHeaders = this.OrderGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["header"]});
    this.TradeCSVGridHeaders = this.TradeGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["header"]});
    this.RouteCSVGridHeaders = this.RouteGridCols.map(function(gridItem: { [x: string]: any; }) {return gridItem["header"]});

  }

  ngOnInit() {
    this.selectedTab.setValue(0);
    this.subscription = this.emitterService.isODROrderViewerOpenCloseEvent.subscribe({
      next: (event: any) => {
        if (event.display == true) {
          this.PageName = event.pageName;
          this.isOpenClose = event.display;
          this.SelectedRow[0] = event.rowData;
          this.setFilterArrayValue(this.SelectedRow[0]);
          this.openAccordion();
          this.getODROrderViewerData();
        }
      }
    });
  }


  closeDialogbox() {
    this.isOpenClose = false;
    this.closeAccordion();
    this.checkedAccordationView = true;
    this.panelOpenState = true;
    this.FilterData = [];
    this.SelectedRow = [];
    this.Orderdataset = [];
    this.Tradedataset = [];
    this.Routedataset = [];
  }


  setFilterArrayValue(Data: any) {
    let rowObj = Data;
    this.OrderId = "";
    this.OSMId = "";
    this.ComplianceOrderId = "";
    this.Symbol = "";
    if (rowObj != null) {
      let fromdate: any;
      let todate: any;
      fromdate = (rowObj['reportDate']);
      todate = (rowObj['reportDate']);
      this.OrderId = rowObj['orderID'];
      this.ComplianceOrderId = rowObj['orderID'];
      this.Symbol = rowObj['symbol'];
      this.OSMId = rowObj['orderID'];
      this.fromdate = this.UserService.getyyyyMMddDate(fromdate);
      this.todate = this.UserService.getyyyyMMddDate(todate);
    }
    let ydate = new Date(this.fromdate);
    this.fromdate = this.datePipe.transform(new Date(ydate.setDate(ydate.getDate() - 1)), "yyyy-MM-dd");
  }


  getOrderViewerData(fromdate: any, todate: any, orderID: any, symbol: any, limit: any, pageName: any) {

    let Data = {
      "mpid": this.UserService.getActiveMPID(),
      "reportDate": todate,
      "orderID": orderID,
      "symbol": symbol,
      'pageName': pageName
    };
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.ODR_Order_Viewer), Data)
      .pipe(map((response: Response) => {
        return response;
      }));
  }


  getODROrderViewerData() {
    this.isOrderdatasetLoading = true;
    this.isRoutedatasetLoading = true;
    this.isTradedatasetLoading = true;
    this.getOrderViewerData(this.fromdate, this.todate, this.OrderId, this.Symbol, this.Limit, this.PageName)
      .subscribe({
        next: (Element: any) => {
          this.isOrderdatasetLoading = false;
          this.isRoutedatasetLoading = false;
          this.isTradedatasetLoading = false;
          let dataset: any = Element;
          this.Orderdataset = [];
          this.Orderdataset = dataset['order']['Data'];
          this.Routedataset = [];
          this.Routedataset = dataset['route']['Data'];
          this.Tradedataset = [];
          this.Tradedataset = dataset['trade']['Data'];
        }, error: (err: HttpErrorResponse) => {
          this.isOrderdatasetLoading = false;
          this.isRoutedatasetLoading = false;
          this.isTradedatasetLoading = false;
        }
      });
  }


  exportToCSV1(pageType: string) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    let data = this.Orderdataset;
    if (data.length > 0) {
      data.forEach((col: { originalJSON: any; }) => {
        delete col.originalJSON;
      });
      const options: any = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: 'RSMS_ODR_ORDER_VIEWER_' + this.UserService.getyyyyMMddDateFormate(new Date()),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        filename: this.UserService.getActiveMPID() + '_RSMS_ODR_ORDER_VIEWER_' + this.UserService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
      };
      const csvData = this.constantService.getExportData(data, this.OrderGridCols);
      const csv = generateCsv(options)(csvData);
      const blob = asBlob(options)(csv);
      saveAs(blob, options.filename);
      this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'No data found',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }
  }


  exportToCSV(pageType: string) {
    if (this.UserService.enableFileExport()) {
      // to let user know the button is clicked and download process is started
      this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });
      this.exportCSV(this.Orderdataset, this.Tradedataset, this.Routedataset);

    }
  }

  exportCSV(Orderdataset: string | any[], Tradedataset: string | any[], Routedataset: string | any[]) {
    if (this.UserService.enableFileExport()) {
      let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

      const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
      if (filterData.values.length === 2) {
        filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
        filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
      }

      // Export Order Viewer Detail CSV
      if (Orderdataset.length === 0 && Tradedataset.length === 0 && Routedataset.length === 0) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        let CSVData = "";
        let OrderTableData: any[] = [], TradeTableData: any[] = [], RouteTableData: any[] = [];
        if(Orderdataset.length > 0) {
          OrderTableData = this.constantService.prepareCSVDataSet(this.OrderCSVGridHeaders, this.OrderCSVGridHeaders, Orderdataset,this.booleanFieldList);
        }
        if(Tradedataset.length > 0) {
          TradeTableData = this.constantService.prepareCSVDataSet(this.TradeCSVGridHeaders, this.TradeCSVGridHeaders, Tradedataset,this.booleanFieldList);
        }
        if(Routedataset.length > 0) {
          RouteTableData = this.constantService.prepareCSVDataSet(this.RouteCSVGridHeaders, this.RouteCSVGridHeaders, Routedataset,this.booleanFieldList);
        }
        CSVData += 'ODR_Order_Viewer_Detail_' + this.UserService.getyyyyMMddDateFormate(new Date()) + "\n\n";
        CSVData += "************Order Data************\n\n";
        CSVData += (OrderTableData.length > 0 ? OrderTableData.join("\n") : "No Data Found") + "\n\n\n";
        CSVData += "************Trade Data************\n\n";
        CSVData += (TradeTableData.length > 0 ? TradeTableData.join("\n") : "No Data Found") + "\n\n\n";
        CSVData += "************Route Data************\n\n";
        CSVData += (RouteTableData.length > 0 ? RouteTableData.join("\n") : "No Data Found");

        let fileName = this.UserService.getActiveMPID() + '_RSMS_Order_Viewer_' + this.UserService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()) + ".csv";
        const a = document.createElement("a");
        a.href = URL.createObjectURL(new Blob([CSVData], { type: "text/csv" }));
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully, Order Data Count: ' + (this.Orderdataset.length > 0 ? this.Orderdataset.length : 0) + ', Trader Data Count: ' + (this.Tradedataset.length > 0 ? this.Tradedataset.length : 0) + ', Route Data Count: ' + (this.Routedataset.length > 0 ? this.Routedataset.length : 0) + ' records downloaded with file name: ' + fileName + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    }
  }



  closeAccordion() {
    this.expandedPanel.fill(false);
  }

  openAccordion() {
    this.expandedPanel.fill(true);
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}